import React from "react";

const Introduction = [
  {
    p: "This privacy policy (“Privacy Policy”), read together with the terms of use located at www.ELiNAservices.in/termsofuse (“Terms of Use”) constitute a legal and binding agreement (“Agreement”) between You (hereinafter referred to as “You”, or “Your” or “User(s)” and Vimarshi Solutions Private Limited and its brand “ELiNA” (the “Company”), having its registered office C1-301, Pelican Nest, Creek Street, Okkium Thoraipakkam,Chennai, India and provides, inter alia, the terms that govern Your access and use of the Company’s website, Services and products (“Website”).",
  },
  {
    p: "The Company owns and operates the Website, providing details about the Company, its Services and products offered by it. The Company is committed to protect the customers’ privacy and ensure You that they have a positive experience on the Website.",
  },
  {
    p: "This Privacy Policy describes the Company’s policies and procedures on the collection and procedures on the collection, use and disclosure of the information provided by the end users and the visitors of the Website (together referred to as the “Users”). The Company shall not use the User’s information in any manner except as provided under this Privacy Policy. Every User who accesses or uses the Website agrees to be bound by the terms of this Privacy Policy and terms of service.",
  },
  {
    p: (
      <span>
        This Privacy Policy is published in compliance of:
        <ul className="list-decimal">
          <li>Section 15A of the Information Technology Act, 2000;</li>
          <li>
            Regulation 4 of the Information Technology (Reasonable Security
            Practices and Procedures and Sensitive Personal Information) Rules,
            2011 (the “SPI Rules”)
          </li>
          <li>
            Regulation 3(1) of the Information Technology (Intermediaries
            Guidelines) Rules, 2011.
          </li>
        </ul>
      </span>
    ),
  },
  {
    p: "The Website/Services/products records the information You provide when You download and register for the Services or products. When You register with us, You generally provide (a) Your name, age, email address, phone number, password and Your ward’s educational strengths & weakness associated behaviours; (b) transaction-related information, such as when You make purchases, respond to any offers, or download or use applications from us; (c) information You provide us when You contact us for help; (d) information You enter into its system when using the Services/products, such as while asking doubts, participating in discussions and taking tests. The said information collected from the users could be categorized as “Personal Information”, “Sensitive Personal Information”. Personal Information, Sensitive Personal Information and Associated Information shall have the meaning as individually defined under this Information Technology (Reasonable security practices and procedures and sensitive personal data or information) Rules, 2011.",
  },
];

const Privacy = [
  {
    p: "Accordingly, a condition of each User’s use of and access to the Website and to the Services is their acceptance of the Terms of Use, which also involves acceptance of the terms of this Privacy Policy. Any User that does not agree with any provisions of the same is required to leave the Website immediately.",
  },
  {
    p: "Except as otherwise provided herein, when browsing the Website, a User is not required to provide Personal Information unless and until such User chooses to submit his/her Personal Information in the Website.",
  },
  {
    p: "Due to the communications standards on the internet, when a User visits the Website, the Company automatically receives the uniform resource locator (URL) of the site from which such User came and the site to which such User is going when he/she/it leaves the Website. The Company also receives the Internet Protocol (the “IP”) address of each User’s computer (or the proxy server a User used to access the internet), the User’s computer operating system and type of web browser the User is using, email patterns, as well as the name of User’s internet service provider (ISP). This information is used to analyze overall trends to help the Company improve its Service. The linkage between User’s IP address and User’s personally identifiable information is not shared with third parties without such User’s permission or except when required by law or except where required to provide or facilitate the Services. Notwithstanding the above, the User acknowledges the Company’s right to share some of the aggregate findings (not the specific data) with advertisers, sponsors, investors, strategic partners, and others in order to help grow its business.",
  },
  {
    p: "The Company may display interest-based advertising using information You make available to us when You interact with our Website, content, or services. Interest-based ads, also sometimes referred to as personalised or targeted ads, are displayed to You based on information from activities such as subscription on the Website, visiting sites that contain Company’s content or ads. In providing interest-based ads, we follow applicable laws, as well as the Code for Self-Regulation in Advertising by the Advertising Standards Council of India and the Self-Regulatory Principles for Online Behavioural Advertising developed by the Digital Advertising Alliance (a coalition of marketing, online advertising, and consumer advocacy organizations).",
  },
  {
    p: "Like other online ad networks, the Company uses cookies, web beacons (also known as action tags or single-pixel gifs), and other technologies (collectively, “cookies”). Cookies enable the Company to learn about what ads You see, what ads You click, and other actions You take on our sites and other sites. This allows the Company to provide You with more useful and relevant ads. For example, if the Company knows what ads You are shown it can be careful not to show You the same ones repeatedly. The Company does not associate Your interaction with unaffiliated sites with Your identity in providing You with interest-based ads.",
  },
  {
    p: "In addition, while receiving Services, the Company may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile devices unique device ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browsers You use, and information about the way You use the Application/Services/products. As is true for most Mobile applications (if used by the User), Company also collects other relevant information as per the permissions that You provide.",
  },
  {
    p: "The Company do not provide any Personal Information to advertisers or to third party sites that display Company’s interest-based ads. However, advertisers and other third-parties (including the ad networks, ad-serving companies, and other service providers they may use) may assume that users who interact with or click on a personalised ad or content are part of the group that the ad or content is directed towards. Also, some third-parties may provide the Company with information about You (such as the sites where You have been shown ads or demographic information) from offline and online sources that Company may use to provide You more relevant and useful advertising.",
  },
  {
    p: "Advertisers or ad companies working sometimes use technology to serve the ads that appear on Company Website directly to Your browser. Such companies automatically receive Your IP address during serving and providing ad service. Such companies may also use Cookies to measure the effectiveness of their ads and to personalise ad content. The Company does not have access to or control over Cookies or other features that advertisers and third party sites may use, and the information practices of these advertisers and third party websites are not covered by Company’s Privacy Policy. Please contact such advertisers or companies directly for more information about their privacy practices.",
  },
  {
    p: "Company uses an outside payment gateway company to bill You for the services availed by You. These companies do not retain, share, store or use personally identifiable information belonging to You for any other purpose and the Company does not take any responsibility and liability with respect to the use of such personally identifiable information whatsoever.",
  },
  {
    p: "The Website uses temporary cookies to store certain data (that is not sensitive personal data or information) that is used by the Company and its service providers for the technical administration of the Website, research and development, and for User administration. In the course of serving advertisements or optimizing services to its Users, the Company may allow authorized third parties to place or recognize a unique cookie on the User’s browser. The Company does not store personally identifiable information in the cookies.",
  },
  {
    p: "A User can set or amend his/her/its application settings to delete or disable cookies. If a User chooses to disable cookies on his/her/its computer or mobile telecommunication device, it may impair, degrade or restrict access to certain areas of the Website. Merely closing the Website should ordinarily clear all temporary cookies installed by Website. However, Users are encouraged to use the “clear cookies” functionality of their browsers to ensure deletion, as the Company cannot guarantee, predict or provide for the behaviour of the equipment of all the Users of the Website.",
  },
  {
    p: "The Website may enable User to communicate with other Users or to post information to be accessed by others, whereupon other Users may collect such data. The Company hereby expressly disclaims any liability for any misuse of such information that is made available by visitors in such a manner.",
  },
  {
    p: "The Company does not collect information about the Users of the Website from other sources, such as public records or bodies, or private organisations, save and except as provided in this Privacy Policy.",
  },
  {
    p: "The Company may keep records of Personal Information received from the Users for the purpose of (i) administration of the Website, (ii) rectifying any error (iii) research and development, (iv) business development, (v) using such Personal Information to contact the User to provide details about the Services or (vi) for User administration.",
  },
  {
    p: "System Logs and Maintenance: For operation and maintenance purposes, this Website and any third party services may collect files that record interaction with this Website (System Logs) or use for this purpose other Personal Information (such as IP Address).",
  },
  {
    p: "The Company has implemented Indian legal industry standard security policies, rules and technical measures to protect the personal data that it has under its control from unauthorised access, improper use or disclosure, unauthorised modification and unlawful destruction or accidental loss. It is expressly stated that the Company shall not be responsible for any breach of security or for any actions of any third parties that receive the Users’ personal data or events that are beyond the reasonable control of the Company including, acts of government, computer hacking, unauthorized access to computer data and storage device, computer crashes, breach of security and encryption, etc.",
  },
  {
    p: "The Company will not disclose any Personal Information or data to governmental institutions or authorities unless such disclosure is requisitioned under any Indian law or judicial decree or when the Company, in its sole discretion, deems it necessary in order to protect its rights or the rights of others, to prevent harm to persons or property, to fight fraud and credit risk, or to enforce or apply our Terms of Use.",
  },
  {
    p: "The Company does not make any unsolicited calls or otherwise market any products or services, except for in relation to the purpose for which such information has been provided or taking any feedback, addressing any complaints, informing You about new features or free/paid courses. User shall not disclose their Personal Information to any third parties that has not been authorised by the Company. The Company will communicate with the Users through call, SMS, email or notices posted on the Website or through any other means available, which shall include but not be limited to text, other forms of messaging, calls, etc.",
  },
  {
    p: "The Company may, only if You so opt, send direct mailers to You at the address given by You. You have the option to ‘opt-out’ of this direct mailer by way of links provided at the bottom of each mailer. We respect Your privacy and to the extent that You choose not to receive such mailers, we will take all steps to remove You from the list. Should You evidence any violation of our terms and policies, please write to us info@ELiNAservices.in and report such incident.",
  },
];

const Visitors = [
  {
    p: "No sensitive personal data or information is automatically collected by the Company from any casual visitors of this Website, who are merely perusing or browsing the Website, except when You use the Services listed on the Website.",
  },
  {
    p: "Nevertheless, certain provisions of this Privacy Policy are applicable to even such casual visitors, and such casual visitors are also required to read and understand the privacy statements set out herein, failing which they are required to leave this Website immediately.",
  },
  {
    p: "If You, as a casual visitor, have inadvertently browsed any other pages of this Website prior to reading the privacy statements set out herein, and You do not agree with the manner in which such information is obtained, stored or used, merely quitting this browser application should ordinarily clear all temporary cookies installed by the Company. All visitors, however, encouraged to use the “clear cookies” functionality of their browsers to ensure such clearing / deletion, as the Company cannot guarantee, predict or provide for the behaviour of the equipment of all the visitors of the Website.",
  },
  {
    p: "You are not a casual visitor if You have willingly submitted any personal data or information to the Company through any means, including email, post on the Website. All such visitors will be deemed to be, and will be treated as, Users for the purposes of this Privacy Policy, and in which case, all the statements in this Privacy Policy apply to such persons.",
  },
];
const Collection = [
  {
    p: "As part of the Services the Company may collect the following Personal Information from the Users (i) name, (ii) gender, (iii) age, (iv) contact information including locations, email address and mobile number, (v) password chosen by the User, (vi) demographic information such as postal code, preferences, interests, etc., and (vii) other information as the User may provide",
  },
  {
    p: "The information specified in clause IV(1) above is collected on for reasons including but not limited to, (i) personal identification, (ii) to allow the Company to contact the User for customer service and business development purposes, (iii) to customize the content of the App to meet specific needs of the User, and/or (iv) to make improvements to the Website.",
  },
  {
    p: "The User may also receive updates about special offers, new services, and other noteworthy events. However, the User may, at any time choose to no longer receive such types of emails.",
  },
  {
    p: "This type of services allows this Website to monitor the use and behaviour of its components so its performance, operation, maintenance and troubleshooting can be improved.",
  },
  {
    p: "By registering with the Company, You are expressly consenting to its collection, processing, storing, disclosing and handling of Your information as set forth in this Privacy Policy now and as amended by the Company. Processing, Your information in any way, including, but not limited to, collecting, storing, deleting, using, combining, sharing, transferring and disclosing information, all of which activities will take place in India. If You reside outside India Your information will be transferred, processed and stored in accordance with the applicable data protection laws of India.",
  },
];

const Access = [
  {
    p: (
      <span>
        All the information, including Personal Information, provided by the
        Users (the “User Information”) is maintained by the Company in
        electronic form on online servers/cloud systems and shall be accessible
        by certain employees of the Company as mentioned below. The User
        Information may also be converted to physical form from time to time.
        Regardless of the manner of storage, the Company will keep all User
        Information confidential, and will only disclose User Information to the
        persons mentioned below:
        <ul>
          {" "}
          <li>
            Its employees on a need-to-know basis. All the Company employees and
            data processors, who have access to, and are associated with the
            processing of User Information, are obliged to respect the
            confidentiality of User Information.
          </li>
          <li>
            {" "}
            Third party service providers to the extent necessary to provide the
            Users with the Service. The Company may provide the User Information
            to third party service providers to work on behalf of or with the
            Company to provide the Users with the Service, to help the Company
            communicate with the Users or to maintain the Website. Generally the
            third party service providers do not have any independent right to
            share this information, however certain service providers who
            provide services on the Portal, including the providers of online
            communications services, will have rights to use and disclose the
            User Information collected in connection with the provision of these
            services in accordance with their own privacy policies.
          </li>
          <li>
            Notwithstanding the above, the Company shall not responsible for any
            breach of security or for any actions of any third parties that
            receive the User Information or events that are beyond the
            reasonable control of the Company including, acts of government,
            computer hacking, unauthorised access to computer data and storage
            device, computer crashes, breach of security and encryption, etc.
          </li>
        </ul>
      </span>
    ),
  },
  {
    p: "This type of services allows User Data to be utilized for advertising communication purposes displayed in the form of banners and other advertisements on this Website, possibly based on User interests. This does not mean that all Personal Information are used for this purpose. Some of the services listed in the Website may use Cookies to identify Users or they may use the behavioural retargeting technique, i.e. displaying ads tailored to the User’s interests and behaviour, including those detected outside this Website.",
  },
  {
    p: "The Company uses Your personally identifiable, registration, and location information to operate, maintain, and provide to You and other Users all of the features and functionality of the Service. The Company uses Your personally identifiable, location, and certain non-personally-identifiable information (such as anonymous log file information and unique device ID to track and analyse User preferences and trends in order to improve the quality and design of the Services and to create new features, promotions, functionality, and services. It uses cookies and log file information to: (a) remember information so that You will not have to re-enter it during Your visit or the next time You visit the Services; (b) provide custom and personalized content, advertisements, and information; (c) monitor the effectiveness of our marketing campaigns; and (d) monitor aggregate usage metrics. We use Your email address from time-to-time for non-marketing or administrative purposes such as sending privacy or security related notices, notifying You of major Services changes, or for other customer service purposes. We do not use Your personally identifiable information or location information to send commercial or marketing SMS text messages or email messages to You without Your express consent or unless if You have opted-in to be part of a specific program or feature in accordance with the applicable Services consent procedures. The Company will also use this information in order to track the phone/device and facilitate retrieval in the event of any theft.",
  },
  {
    p: "The Company may retain User data while an account is active and for at least three years afterwards. It may alter this practice according to legal and business requirements. For example, it may lengthen the retention period for some data if needed to comply with law or voluntary codes of conduct. Unless otherwise prohibited, it may shorten the retention period for some types of data if needed to free up storage space.",
  },
];

const Registration = [
  {
    p: "As part of the registration process, the Company may collect the following Personal Information from the Users (i) name, (ii) gender, (iii) age, (iv) contact information including locations including email address and mobile number, (v) password chosen by the User, and (vi) other information as the User may provide.",
  },
  {
    p: "This information specified in clause VI (1) above is collected on the registration form for several reasons including but not limited to, (i) personal identification, (ii) to allow the Company to contact the User for customer service and business development purposes, (iii) to customize the content of the Website to meet specific needs of the User, and/or (iv) to make improvements to the Website.",
  },
  {
    p: "In addition, the email address provided by the end User will be used to confirm his/her/its new registration and each transaction that is initiated. As a member of Website, the End User may also receive updates about new services, and other noteworthy events.",
  },
];
const Changes = [
  {
    p: "The Users acknowledge that this Privacy Policy is part of the Terms of Use and unconditionally agree that becoming a User of the Website and its Services signifies their assent to this Privacy Policy.User’s visit and any dispute over privacy is subject to this policy and Terms of Use. The Company may update this Privacy Policy at any time, with or without advance notice. In the event there are significant changes in the way the Company treats User’s personally identifiable information, the Company will display a notice on the Website or send Users an email, as provided for above. Unless stated otherwise, this current Privacy Policy applies to all information that the Company has about Users and their account. Notwithstanding the above, the Company shall not be required to notify the Users of any changes made to the Privacy Policy.",
  },
  {
    p: "If a User uses the Service after notice of changes have been sent to such User or published on the Website, such User hereby provides his/her/its consent to the changed practices.",
  },
];
const Users = [
  {
    p: "You must, at all times, adhere to the Terms of Use and this Privacy Policy. This includes not misusing all intellectual property rights which may belong to the Company’s third parties.",
  },
  {
    p: "You must not create or otherwise disseminate any information which may be deemed to be injurious, violent, offensive, racist or xenophobic or which may otherwise violate the purpose and spirit of the Company and its community of Users.",
  },
  {
    p: "You must not provide information to the Company and /or other Users which You believe might be injurious or detrimental to Your person, professional or social status.",
  },
  {
    p: "Any violation of this Privacy Policy may lead to the restriction, suspension or termination of Your account by the Company, as we take these principles seriously and consider them to be the basis on which our Users adhere to the Company policies and the Services which it offers.",
  },
];
const Discrepancy = [
  {
    p: (
      <span>
        The Company shall address any discrepancies and grievances of all Users
        with respect to processing of information in a time bound manner. For
        this purpose, the Company has designated Ms. Ramalakshmi as the
        ‘Grievance Officer’, who will redress the grievances of the Users
        expeditiously but within 1 (one) month from the date of receipt of
        grievance, and who can be reached by:
        <ul>
          {" "}
          <li>
            Sending a letter marked to the attention of Ramalakshmi to Vimarshi
            Solutions Private Limited, C1-301, Pelican Nest, Creek Street,
            Okkium Thoraippakkam, Chennai 600097
          </li>
          <li> Sending an email to infor@ELiNAservices.in</li>
        </ul>
      </span>
    ),
  },
];

const UserRightsandDataDeletion = [
  {
    p: (
      <>
        <span>
          <li>
            <span className="font-bold">Access and Review Data:</span> Request a
            copy of the personal data collected by the Company.
          </li>
          <li>
            <span className="font-bold">Opt-Out of Data Collection:</span>{" "}
            Request to opt-out of non-essential data collection or targeted
            advertising by contacting us.
          </li>
          <li>
            <span className="font-bold">Data Deletion: </span> Request deletion
            of personal data collected by the Company by sending an email to our
            Grievance Officer.
          </li>
          <li>
            <span className="font-bold">Withdraw Consent: </span> Withdraw
            consent to data collection at any time without affecting the
            legality of prior data processing. All requests will be processed
            within 30 days.
          </li>
        </span>
      </>
    ),
  },
];
const childProtection = [
  {
    p: (
      <>
        <span>
          The Company does not knowingly collect personal information from
          children under the age of 13. If you are a parent or guardian and
          believe that your child has provided personal data, please contact us
          immediately. We will take steps to delete such data from our systems.
        </span>
      </>
    ),
  },
];

const PrivacyPolicy = () => {
  return (
    <div className="md:mx-[10%] mx-[2%]  helloPrivacy text-justify">
      <h1 className="flex justify-center text-5xl font-black text-white bg-pink-600 underline py-3">
        Privacy policy
      </h1>
      <section>
        <h1>Introduction</h1>
        <ul className="list-disc">
          {Introduction.map((item, index) => (
            <li key={index}>{item.p}</li>
          ))}
        </ul>
      </section>
      <section>
        <h1>Privacy Statements</h1>
        <ul className="list-disc">
          {Privacy.map((item, index) => (
            <li key={index}>{item.p}</li>
          ))}
        </ul>
      </section>
      <section>
        <h1>Visitors Note</h1>
        <ul className="list-disc">
          {Visitors.map((item, index) => (
            <li key={index}>{item.p}</li>
          ))}
        </ul>
      </section>
      <section>
        <h1>Collection Process</h1>
        <ul className="list-disc">
          {Collection.map((item, index) => (
            <li key={index}>{item.p}</li>
          ))}
        </ul>
      </section>
      <section>
        <h1>Access of Information</h1>
        <ul className="list-disc">
          {Access.map((item, index) => (
            <li key={index}>{item.p}</li>
          ))}
        </ul>
      </section>

      <section>
        <h1>Changes to Privacy Policy</h1>
        <ul className="list-disc">
          {Changes.map((item, index) => (
            <li key={index}>{item.p}</li>
          ))}
        </ul>
      </section>
      <section>
        <h1>Users Obligations</h1>
        <ul className="list-disc">
          {Users.map((item, index) => (
            <li key={index}>{item.p}</li>
          ))}
        </ul>
      </section>
      <section>
        <h1>Discrepancy and Grievance Redressal</h1>
        <ul className="list-disc">
          {Discrepancy.map((item, index) => (
            <li key={index}>{item.p}</li>
          ))}
        </ul>
      </section>
      <section>
        <h1>User Rights and Data Deletion</h1>
        <p className="text-lg my-2 font-semibold">Users have the right to:</p>

        <ul className="list-disc">
          {UserRightsandDataDeletion.map((item, index) => (
            <p key={index}>{item.p}</p>
          ))}
        </ul>
      </section>

      <section>
        <h1>Child Protection (COPPA)</h1>

        <ul className="list-disc">
          {childProtection.map((item, index) => (
            <li key={index}>{item.p}</li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
